'use strict';

import BodyParameter        from './Parameters/BodyParameter';
import QueryParameter       from './Parameters/QueryParameter';
import UriArgumentParameter from './Parameters/UriArgumentParameter';

/**
 * @property {string}                 caption
 * @property {BodyParameter[]}        bodyParameters
 * @property {boolean}                deprecated
 * @property {string}                 deprecationNotice
 * @property {string}                 description
 * @property {Object<string[]>}       errors
 * @property {boolean}                hidden
 * @property {string}                 id
 * @property {boolean}                internal
 * @property {string[]}               methods
 * @property {string}                 minimumVersion
 * @property {string}                 name
 * @property {boolean}                publiclyAccessible
 * @property {QueryParameter[]}       queryParameters
 * @property {string[]}               scopes
 * @property {string}                 uri
 * @property {UriArgumentParameter[]} uriArguments
 * @property {boolean}                upload
 * @property {Resource}               resource
 */
class Endpoint {
  /**
   * @param {string}            caption
   * @param {Object[]}          bodyParameters
   * @param {boolean}           deprecated
   * @param {string}            deprecationNotice
   * @param {string}            description
   * @param {Object<string[]>}  errors
   * @param {boolean}           hidden
   * @param {string}            id
   * @param {boolean}           internal
   * @param {string[]}          methods
   * @param {string}            minimumVersion
   * @param {string}            name
   * @param {boolean}           publiclyAccessible
   * @param {Object[]}          queryParameters
   * @param {string[]}          scopes
   * @param {string}            uri
   * @param {Object[]}          uriArguments
   * @param {boolean}           upload
   * @param {Resource}          resource
   */
  constructor ( {
                  caption,
                  bodyParameters,
                  deprecated,
                  deprecationNotice,
                  description,
                  errors,
                  hidden,
                  id,
                  internal,
                  methods,
                  minimumVersion,
                  name,
                  publiclyAccessible,
                  queryParameters,
                  scopes,
                  uri,
                  uriArguments,
                  upload,
                }, resource ) {
    this.caption            = caption;
    this.bodyParameters     = bodyParameters.map(bodyParameter => new BodyParameter(bodyParameter));
    this.deprecated         = deprecated;
    this.deprecationNotice  = deprecationNotice;
    this.description        = description;
    this.errors             = errors;
    this.hidden             = hidden;
    this.id                 = id;
    this.internal           = internal;
    this.methods            = methods;
    this.minimumVersion     = minimumVersion;
    this.name               = name;
    this.publiclyAccessible = publiclyAccessible;
    this.queryParameters    = queryParameters.map(queryParameter => new QueryParameter(queryParameter));
    this.resource           = resource;
    this.scopes             = scopes;
    this.uri                = uri;
    this.uriArguments       = uriArguments.map(uriArgument => new UriArgumentParameter(uriArgument));
    this.upload             = upload;
  }

  /**
   * Retrieves all parameters
   *
   * @returns {Parameter[]}
   */
  get parameters () {
    return [].concat(this.bodyParameters, this.queryParameters, this.uriArguments);
  }

  /**
   * Renders the endpoint URI
   *
   * @param   {Object<any>} parameters Parameter values to replace
   * @returns {string}                 Rendered URI
   */
  renderUri ( parameters ) {
    return Object.entries(parameters).reduce(( uri, [ name, value ] ) => {
      return uri.replace(`{${ name }}`, value ? value : `%${ name }%`);
    }, this.uri);
  }

  get slug () {
    return this.name
      .replace(/([a-z0-9])([A-Z])/g, '$1-$2')
      .replace(/([A-Z])([A-Z])(?=[a-z])/g, '$1-$2')
      .toLowerCase();
  }
}

export default Endpoint;
